/* =============================================================
   LA SMOLE · FAUVE — interactions communes
   - ajout au panier (ajout rapide, ensemble haut + bas)
   - notification « ajouté au panier »
   - filtres et densité de grille (vestiaire, collection)
   ============================================================= */
(function () {
  'use strict';
  if (window.Fauve) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function toast(message) {
    var el = document.getElementById('fauve-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'fauve-toast';
      el.className = 'fauve-toast fauve-glass';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  function addItems(items, label) {
    var count = items.reduce(function (n, it) { return n + (it.quantity || 1); }, 0);
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.body && res.body.description ? res.body.description : 'Ajout impossible pour le moment.');
          return false;
        }
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: {}, sourceId: 'fauve', data: { source: 'product-form-component', itemCount: count } }
        }));
        toast((label ? label + ' · ' : '') + 'ajouté au panier');
        return true;
      })
      .catch(function () { toast('Connexion interrompue, réessaie.'); return false; });
  }

  /* Ajout rapide : <button data-fauve-add="VARIANT_ID" data-fauve-label="GEMMA · 80A"> */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fauve-add]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    b.disabled = true;
    addItems([{ id: Number(b.dataset.fauveAdd), quantity: 1 }], b.dataset.fauveLabel).finally(function () { b.disabled = false; });
  });

  /* Filtres client du vestiaire : [data-fauve-grid] + boutons [data-fauve-filter] */
  document.addEventListener('click', function (e) {
    var f = e.target.closest('[data-fauve-filter]');
    if (f) {
      var scope = f.closest('[data-fauve-scope]');
      if (!scope) return;
      var val = f.dataset.fauveFilter;
      scope.querySelectorAll('[data-fauve-filter]').forEach(function (x) {
        var on = x === f; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var n = 0;
      scope.querySelectorAll('[data-fauve-tags]').forEach(function (card) {
        var show = val === '*' || (' ' + card.dataset.fauveTags + ' ').indexOf(' ' + val + ' ') > -1;
        card.hidden = !show; if (show) n++;
      });
      var c = scope.querySelector('[data-fauve-count]'); if (c) c.textContent = n;
      return;
    }
    var d = e.target.closest('[data-fauve-cols]');
    if (d) {
      var sc = d.closest('[data-fauve-scope]');
      if (!sc) return;
      var grid = sc.querySelector('[data-fauve-grid]');
      grid.style.setProperty('--fauve-cols', d.dataset.fauveCols);
      sc.querySelectorAll('[data-fauve-cols]').forEach(function (x) {
        var on = x === d; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      try { localStorage.setItem('fauve-cols', d.dataset.fauveCols); } catch (err) {}
    }
  });
  document.addEventListener('DOMContentLoaded', function () {
    var saved = null;
    try { saved = localStorage.getItem('fauve-cols'); } catch (err) {}
    if (!saved || window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('[data-fauve-scope] [data-fauve-cols="' + saved + '"]').forEach(function (b) { b.click(); });
  });

  window.Fauve = { addItems: addItems, toast: toast };
})();
